import { Autocomplete, Box, Grid, MenuItem, Paper, Skeleton, Typography, styled, useTheme } from "@mui/material"

import { Bar, Pie } from "react-chartjs-2"
import { CenteredBox } from "../../components/layouts/OneViewBox"
import Counts from "./Counts"
import { memo } from "react"
import { REGIONS_TYPE } from "../../utils/constants"

const RegionsCounts = ({ list, loading }) => {
    
    const finalData = [0, 0,0,0]


    if (list && Array.isArray(list) && list.length > 0) {
        for (let item of list) {
            if (item._id==REGIONS_TYPE.COUNTRY) {
                finalData[0] = item.count
            } else if(item._id==REGIONS_TYPE.STATE) {
                finalData[1] = item.count
            }
            else if(item._id==REGIONS_TYPE.DISTRICT) {
                finalData[2] = item.count
            }
            else if(item._id==REGIONS_TYPE.TALUKA) {
                finalData[3] = item.count
            }

        }
    }

    if (loading) {
        return (
            <>
                {[0, 1, 2, 3].map((item) => <Grid item xs={6} md={3} key={item}>

                    <Paper component={Box} p={2}>
                        <Skeleton variant="rounded" height="120px" width="100%" >

                        </Skeleton>
                    </Paper>
                </Grid>)}


            </>)
    }
    if (!(list && Array.isArray(list) && list.length > 0)) {
        return <></>
    }
    return <>
        <Grid item xs={6} md={3}>
            <Counts title="Countries"  count={finalData[0]} />

        </Grid>
        <Grid item xs={6} md={3}>
        <Counts title="States"  count={finalData[1]} />
        </Grid>
        <Grid item xs={6} md={3}>
        <Counts title="Districts"  count={finalData[2]} />
        </Grid>
        <Grid item xs={6} md={3}>
        <Counts title="Talukas"  count={finalData[3]} />
        </Grid>
    </>
}
export default memo(RegionsCounts)